module.exports = __webpack_public_path__ + "web/img/mvp-img2.f1acfece.png";